import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBookOpen, faShareNodes } from "@fortawesome/free-solid-svg-icons";

const SECTIONS = [
  {
    to: "/admin/community",
    title: "Community submissions",
    body: "Review lessons and courses teachers submitted to the community catalog. Approve or reject with feedback.",
    icon: faShareNodes,
  },
  {
    to: "/admin/standards",
    title: "Standards & glossary",
    body: "Upload standards PDFs, run AI extraction, edit drafts, and publish sets teachers align lessons to.",
    icon: faBookOpen,
  },
] as const;

export default function AdminConsolePage() {
  return (
    <div className="admin-console-grid">
      {SECTIONS.map((section) => (
        <Link key={section.to} to={section.to} className="card admin-console-card">
          <FontAwesomeIcon icon={section.icon} className="admin-console-card-icon" fixedWidth />
          <h2>{section.title}</h2>
          <p className="muted">{section.body}</p>
          <span className="admin-console-card-cta">Open</span>
        </Link>
      ))}
    </div>
  );
}
